type Testimonial = {
  role: string;
  quote: string;
};

export function Testimonials({
  title,
  items,
}: {
  title: string;
  items: Testimonial[];
}) {
  return (
    <section className="border-y border-border bg-gradient-to-b from-card to-surface/40 py-14">
      <div className="mx-auto max-w-6xl px-4">
        <h2 className="text-center text-sm font-medium uppercase tracking-wider text-muted">
          {title}
        </h2>
        <div className="mt-10 grid gap-10 md:grid-cols-3 md:gap-8">
          {items.map((item) => (
            <blockquote key={item.role} className="text-center md:text-start">
              <p className="text-base leading-relaxed text-foreground/90">
                “{item.quote}”
              </p>
              <footer className="mt-4 text-sm font-medium text-muted">
                {item.role}
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
